module.exports = __webpack_public_path__ + "536a5445fa9e370fb75831a6a68b317c.svg";